type GroupableTariff = { id: string; quantity: number };

export const groupTariffsById = <T extends GroupableTariff>(tariffs: T[] | undefined): (T & { quantity: number })[] => {
  const grouped = (tariffs ?? []).reduce((acc, current) => {
    if (!acc[current.id]) {
      acc[current.id] = { ...current, quantity: 0 };
    }

    acc[current.id]!.quantity += current.quantity;

    return acc;
  }, {} as Record<string, T & { quantity: number }>);

  return Object.values(grouped);
};
